<div class="tab-container">

<mat-tab-group>

    <!-- Tab 1 -->
    <mat-tab label="Description">
        <mat-card class="generator-form-card">
            <mat-card-content>
              <form [formGroup]="generatorForm" >
          
                <div class="form-grid">
          
                  <mat-form-field appearance="outline">
                    <mat-label>Generator ID</mat-label>
                    <input matInput formControlName="generatorId" placeholder="Enter Generator ID">
                  </mat-form-field>
          
                  <mat-form-field appearance="outline">
                    <mat-label>Installation Date</mat-label>
                    <input matInput [matDatepicker]="installPicker" formControlName="installationDate">
                    <mat-datepicker-toggle matSuffix [for]="installPicker"></mat-datepicker-toggle>
                    <mat-datepicker #installPicker></mat-datepicker>
                  </mat-form-field>
          
                  <mat-form-field appearance="outline">
                    <mat-label>Capacity (kVA)</mat-label>
                    <input matInput type="number" formControlName="capacity" placeholder="e.g. 200">
                  </mat-form-field>
          
                  <mat-form-field appearance="outline">
                    <mat-label>Fuel Type</mat-label>
                    <mat-select formControlName="fuelType">
                      <mat-option *ngFor="let fuel of fuelTypes" [value]="fuel">{{ fuel }}</mat-option>
                    </mat-select>
                  </mat-form-field>
          
                  <mat-form-field appearance="outline">
                    <mat-label>Manufacturer Name</mat-label>
                    <input matInput formControlName="manufacturerName" placeholder="Enter manufacturer">
                  </mat-form-field>
          
                  <mat-form-field appearance="outline">
                    <mat-label>Model Number</mat-label>
                    <input matInput formControlName="modelNumber" placeholder="Enter model number">
                  </mat-form-field>
          
                  <mat-form-field appearance="outline">
                    <mat-label>Rated Voltage</mat-label>
                    <input matInput type="number" formControlName="ratedVoltage" placeholder="e.g. 415">
                  </mat-form-field>
          
                  <mat-form-field appearance="outline">
                    <mat-label>Rated Current</mat-label>
                    <input matInput type="number" formControlName="ratedCurrent" placeholder="e.g. 50">
                  </mat-form-field>
          
                  <mat-form-field appearance="outline">
                    <mat-label>Rated Frequency (Hz)</mat-label>
                    <input matInput type="number" formControlName="ratedFrequency" placeholder="e.g. 50">
                  </mat-form-field>
          
                  <mat-form-field appearance="outline">
                    <mat-label>Phase Type</mat-label>
                    <mat-select formControlName="phaseType">
                      <mat-option *ngFor="let phase of phaseTypes" [value]="phase">{{ phase }}</mat-option>
                    </mat-select>
                  </mat-form-field>
          
                  <mat-form-field appearance="outline">
                    <mat-label>Fuel Tank Capacity (Liters)</mat-label>
                    <input matInput type="number" formControlName="fuelTankCapacity" placeholder="e.g. 300">
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>City</mat-label>
                    <input matInput type="text" formControlName="city" placeholder="e.g. Mumbai">
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Fuel Price</mat-label>
                    <input matInput type="text" formControlName="fuelPrice" placeholder="e.g. 90">
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="status">
                      <mat-option *ngFor="let st of statuses" [value]="st">{{ st }}</mat-option>
                    </mat-select>
                  </mat-form-field>
          
                  <mat-form-field appearance="outline">
                    <mat-label>Last Service Date</mat-label>
                    <input matInput [matDatepicker]="servicePicker" formControlName="lastServiceDate">
                    <mat-datepicker-toggle matSuffix [for]="servicePicker"></mat-datepicker-toggle>
                    <mat-datepicker #servicePicker></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Device ID</mat-label>
                    <mat-select formControlName="deviceId">
                      <mat-option *ngFor="let deviceid of deviceMaster" [value]="deviceid">{{ deviceid }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                    
                </div>
              </form>
            </mat-card-content>
          </mat-card>
          
    </mat-tab>
  
    <!-- Tab 2 -->
    <mat-tab label="Parameters">
      <mat-card class="param-card">
        <mat-card-content>
          <form [formGroup]="parameterForm" >
      
            <!-- Parameters Grid -->
            <div formArrayName="parameters" class="param-grid">
              <div *ngFor="let param of parameters.controls; let i = index" [formGroupName]="i" class="param-item">
      
                <!-- Name -->
                <mat-form-field appearance="outline" class="param-input">
                  <mat-label>Parameter Name</mat-label>
                  <input matInput formControlName="name" placeholder="Enter Parameter Name">
                </mat-form-field>
      
                <!-- Toggle -->
                <mat-slide-toggle formControlName="enabled" class="param-toggle">
                  
                </mat-slide-toggle>
      
                <!-- Delete -->
                <button mat-icon-button color="warn" type="button" (click)="removeParameter(i)" *ngIf="parameters.length > 1" class="param-delete">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
      
            <!-- Add Parameter Button -->
            <div class="add-btn">
              <button mat-stroked-button color="primary" type="button" (click)="addParameter()">
                + Add Parameter
              </button>
            </div>
      
          </form>
        </mat-card-content>
      </mat-card>
      
          
    </mat-tab>
  
    <!-- Tab 3 -->
    <mat-tab label="Alert Parameter">
      <mat-card class="alert-card">
        <mat-card-content>
          <form [formGroup]="alertParameterForm">
    
            <!-- Alert Parameters List -->
            <div formArrayName="alertParameters">
              <div *ngFor="let param of alertParameters.controls; let i = index" 
                   [formGroupName]="i" class="alert-row">
    
                <!-- Parameter Name -->
                <mat-form-field appearance="outline" class="alert-input">
                  <mat-label>Parameter Name</mat-label>
                  <input matInput formControlName="name" >
                </mat-form-field>
    
                <!-- Threshold -->
                <mat-form-field appearance="outline" class="alert-input">
                  <mat-label>Threshold</mat-label>
                  <input matInput type="number" formControlName="threshold" placeholder="Enter Threshold">
                </mat-form-field>
    
                <!-- Email Toggle -->
                <mat-slide-toggle formControlName="emailToggle" class="alert-toggle">
                  Email
                </mat-slide-toggle>
    
                <!-- Remove -->
                <button mat-icon-button color="warn" type="button" (click)="removealertParameter(i)" 
                  *ngIf="i >= defaultParams.length">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
    
            <!-- Add Custom Parameter -->
            <div class="alert-add-btn">
              <button mat-stroked-button color="primary" type="button" (click)="addalertParameter()">
                + Add Custom Parameter
              </button>
            </div>
    
          </form>
        </mat-card-content>
      </mat-card>
    </mat-tab>
    <mat-tab label="Alert Notifications">
      <mat-card class="notify-card">
        <mat-card-content>
          <form [formGroup]="alertNotificationForm">
            
            <!-- Email List -->
            <div formArrayName="emails" class="email-list">
              <div *ngFor="let email of emailControls.controls; let i = index" [formGroupName]="i" class="email-row">
                
                <!-- Email Input -->
                <mat-form-field appearance="outline" class="email-input">
                  <mat-label>Email {{ i + 1 }}</mat-label>
                  <input matInput formControlName="email" placeholder="Enter email address">
                  <mat-error *ngIf="email.get('email')?.hasError('required')">
                    Email is required
                  </mat-error>
                  <mat-error *ngIf="email.get('email')?.hasError('email')">
                    Enter a valid email
                  </mat-error>
                </mat-form-field>
    
                <!-- Remove Button -->
                <button mat-icon-button color="warn" type="button" (click)="removeEmail(i)" *ngIf="emailControls.length > 1">
                  <mat-icon>delete</mat-icon>
                </button>
    
              </div>
            </div>
    
            <!-- Add New Email -->
            <div class="add-btn">
              <button mat-stroked-button color="primary" type="button" (click)="addEmail()" [disabled]="emailControls.length >= 5">
                + Add Email
              </button>
            </div>
    
          </form>
        </mat-card-content>
      </mat-card>
    </mat-tab>
    

  </mat-tab-group>
  </div>
  <div class="saveButton">  
    <button    [disabled]="!isAllFormsValid()" (click)="saveData()" mat-raised-button color="warn">Save</button>
  </div>
